import useDownloader from "react-use-downloader";
import { getDisplayFileName } from "../../utils";
import defaultUserPic from "../../assets/img/user-profile.svg";
import { memo, useEffect } from "react";


const Preview = ({ currMsg, onClose, setModalAction, handleCheckForwardNessage}) => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const image = currMsg.mediaUrl
  const name = currMsg?.userid === loginData?.id?.toString() ? "You" : currMsg?.userName
  const { download } = useDownloader();

  const handleDownload = () => {
    const imageName = getDisplayFileName(image);
    download(image, imageName);
  };
  useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      // If forward modal is open, close it first
      setModalAction((prev) => {
        if (prev.forwardMsg) {
          return { ...prev, forwardMsg: false };
        } else {
          onClose();
          return prev;
        }
      });
    }
  };
  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [onClose, setModalAction]);

  const handleOnForwardMsg = () => {
    setModalAction(prev => ({ ...prev, forwardMsg: true }))
    handleCheckForwardNessage(currMsg);
  }

  return (
    <div className="preview-modal" onClick={onClose}>
      <div className="preview-content" onClick={(e) => e.stopPropagation()}>
        <div className="prvbtnbox">
          <div  className="user-img">
          <span><img src={ defaultUserPic} alt={name}/></span>
          <span>{name}</span>
          </div>
          
           {/* <button className="close-btn" onClick={onClose}>Close</button> */}
            <div>
              <i title="share" onClick={handleOnForwardMsg} className="fshare-btn fa fa-share " />
              <i title="download" onClick={handleDownload} className="mr-2 download-btn fa fa-download " />
              <i title="close" onClick={onClose}  className="close-btn fa fa-times " />
          </div>
          {/* Download */}
       </div>
        <div className="prvbtnimg"><img src={image} alt="Preview" className="preview-image" /></div>
      </div>
    </div>
  );
};

export default memo(Preview);
